// src/constants/constants.js

export const GOOGLE_LEAD_GENERATION_URL = 'https://docs.google.com/forms/d/1HXnBsUVJKGijhqVKBlaeaEbiAp6LwVLO2eNZTqJmAdY';
